import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ImageVersioningContext from '../context/ImageVersioningContext'

class ImageVersioning extends Component {
  state = {
    version: '',
  }

  setVersion = version => this.setState({ version })

  getUrlWithVersion = (url, version) => `${url}?v=${version || this.state.version}`

  render() {
    return (
      <ImageVersioningContext.Provider
        value={{
          version: this.state.version,
          setVersion: this.setVersion,
          getUrlWithVersion: this.getUrlWithVersion,
        }}
      >
        {this.props.children}
      </ImageVersioningContext.Provider>
    )
  }
}

ImageVersioning.propTypes = {
  children: PropTypes.element.isRequired,
}

export default ImageVersioning
